__turbopack_context__.v({
  "card": "GreyCards-module__s4_dEa__card",
  "cta": "GreyCards-module__s4_dEa__cta",
  "description": "GreyCards-module__s4_dEa__description",
  "wrapper": "GreyCards-module__s4_dEa__wrapper",
});
